// 截取年月日
export function extractDate(dateTimeStr) {
  if (dateTimeStr) {
    const date = new Date(dateTimeStr);
    if (isNaN(date)) {
      console.error('Invalid date string');
      return '';
    }
    const year = date.getFullYear(); // 获取年份
    const month = date.getMonth() + 1; // 获取月份，月份从0开始，所以需要+1
    const day = date.getDate(); // 获取日

    // 返回年月日连在一起的字符串
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  }
}

// 获取年月
export function extractDateList(dateString) {
  if (dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) {
      console.error('Invalid date string');
      return '';
    }
    const year = date.getFullYear(); // 获取年份
    const month = date.getMonth() + 1; // 获取月份，月份从0开始，所以需要+1

    // 返回年月连在一起的字符串
    return `${year}-${month.toString().padStart(2, '0')}`;
  }
}

// 获取日
export function extractDateTime(dateString) {
  if (dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) {
      console.error('Invalid date string');
      return '';
    }
    const day = date.getDate(); // 获取日

    // 返回日的字符串
    return day.toString().padStart(2, '0');
  }
}



// WEBPACK FOOTER //
// ./src/utils/time.js